/** Kind tags of the backend's `OfferIdV2`, serialized as `<kind>:<uuid>` (e.g. the id in `DELETE /offers/:id`). */
export type OfferIdV2Kind =
    | 'PublicOffTheShelf'
    | 'PrivateOffTheShelf'
    | 'InventoryOffTheShelf'
    | 'Custom'
    | 'InventoryCustomPart';

export function formatOfferIdV2(kind: OfferIdV2Kind, id: string): string {
    return `${kind}:${id}`;
}
